import { ANONYMOUS_ID_KEY, COOKIE_DOMAIN, COOKIE_MAX_AGE_DAYS } from './constants';

const createUuid = (): string => {
  if (typeof crypto !== 'undefined' && crypto.randomUUID) {
    return crypto.randomUUID();
  }

  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (char) => {
    const random = Math.floor(Math.random() * 16);
    const value = char === 'x' ? random : (random & 0x3) | 0x8;
    return value.toString(16);
  });
};

const readCookie = (name: string): string | null => {
  if (typeof document === 'undefined') {
    return null;
  }

  const match = document.cookie.match(new RegExp(`(?:^|;\\s*)${name}=([^;]*)`));
  return match?.[1] ? decodeURIComponent(match[1]) : null;
};

export const writeAnonymousIdCookie = (anonymousId: string): void => {
  if (typeof document === 'undefined') {
    return;
  }

  const maxAge = COOKIE_MAX_AGE_DAYS * 24 * 60 * 60;
  const secure = window.location.protocol === 'https:' ? '; Secure' : '';
  document.cookie = `${ANONYMOUS_ID_KEY}=${encodeURIComponent(anonymousId)}; Path=/; Domain=${COOKIE_DOMAIN}; Max-Age=${maxAge}; SameSite=Lax${secure}`;
};

export const getOrCreateAnonymousId = (): string => {
  if (typeof window === 'undefined') {
    return '';
  }

  const fromCookie = readCookie(ANONYMOUS_ID_KEY);
  if (fromCookie) {
    localStorage.setItem(ANONYMOUS_ID_KEY, fromCookie);
    return fromCookie;
  }

  const fromStorage = localStorage.getItem(ANONYMOUS_ID_KEY);
  if (fromStorage) {
    writeAnonymousIdCookie(fromStorage);
    return fromStorage;
  }

  const anonymousId = createUuid();
  localStorage.setItem(ANONYMOUS_ID_KEY, anonymousId);
  writeAnonymousIdCookie(anonymousId);
  return anonymousId;
};
